import FJAIAudioRight from '../view/FJAIAudioRight.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator.js';
import { useMemo } from 'react';

const FJAIAudioRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const historyList = useSelector(state => state.common.historyList);
    const historyListLoadStatus = useSelector(state => state.common.historyListLoadStatus);
    const tabIndex = useSelector(state => state.AIAudioGenerator.tabIndex);
    const subTabIndex = useSelector(state => state.AIAudioGenerator.subTabIndex);

    const presetList = useSelector(state => state.AIAudioGenerator.presetList);
    const sfxPresetList = useSelector(state => state.AIAudioGenerator.sfxPresetList);
    const insPresetList = useSelector(state => state.AIAudioGenerator.insPresetList);

    const usePreviewPresetList = useMemo(() => {
        switch (tabIndex) {
            case 0:
                switch (subTabIndex) {
                    case 0:
                        return presetList;
                    case 1:
                        return insPresetList;
                    default:
                        return presetList;
                }
            case 1:
                switch (subTabIndex) {
                    case 0:
                        return presetList;
                    case 1:
                        return insPresetList;
                    default:
                        return presetList;
                }
            case 2:
                return sfxPresetList;
            default:
                return presetList;
        }
    }, [tabIndex, subTabIndex, presetList, sfxPresetList, insPresetList]);

    const onRetry = () => {
        dispatch(FJActionAIAudioGenerator.updateHistoryListAction());
    };

    const onUsePresetInfo = info => {
        dispatch(FJActionAIAudioGenerator.onUsePresetInfoAction(info));
    };

    return (
        <FJAIAudioRight
            historyList={historyList}
            historyListLoadStatus={historyListLoadStatus}
            onRetry={onRetry}
            presetList={usePreviewPresetList}
            onUsePresetInfo={onUsePresetInfo}
            tabIndex={tabIndex}
            subTabIndex={subTabIndex}
        />
    );
};
export default FJAIAudioRightContainer;
